import { useState, useEffect } from "react";

type ScreenSizes = {
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;
};

const useScreenSize = (): ScreenSizes => {
  const [screenSizes, setScreenSizes] = useState<ScreenSizes>({
    isSmall: false,
    isMedium: false,
    isLarge: false,
    isExtraLarge: false,
  });

  useEffect(() => {
    const updateScreenSizes = () => {
      const width = window.innerWidth;

      setScreenSizes({
        isSmall: width < 600,
        isMedium: width >= 600 && width < 960,
        isLarge: width >= 960 && width < 1921,
        isExtraLarge: width >= 1921,
      });
    };

    // Set the initial screen sizes
    updateScreenSizes();

    // Add event listener for window resize
    window.addEventListener("resize", updateScreenSizes);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", updateScreenSizes);
    };
  }, []);

  return screenSizes;
};

export default useScreenSize;
